import { Button } from '@ucl/react-library/button'
import { Icon } from '@ucl/react-library/icon'
import { RaisedSurface } from '@ucl/react-library/raisedSurface'
import { StyledLink, StyledRaisedSurface, StyledText } from '@components/StyledComponents'
import { getFinSimpleContext, PlatformName, useLogger } from '@fcsmc/react-loading-components'
import { IThemes } from '@ucl/shared-component-foundations'
import { FallbackProps } from 'react-error-boundary'
import { AEMPageProps } from '@ucl/aem-library/aemPage'

const ErrorFallback = (props: FallbackProps & Omit<AEMPageProps<IThemes>, 'fallback' | 'noFallback'>) => {
  const platform = getFinSimpleContext()?.platform.name
  const logger = useLogger()?.logger

  logger?.error(`AEMPagePath: ${props.pagePath}`)

  const handleClick = () => {
    window.location.reload()
  }

  return (
    <StyledRaisedSurface>
      <RaisedSurface.Container style={{ textAlign: 'center' }}>
        <StyledText paddingBottom={'0'}>We experienced an issue. Please try refreshing.</StyledText>
        {platform === PlatformName.FPG && (
          <StyledText>
            If the issue persists contact customer support at{' '}
            <StyledLink to={'tel:+18776335338'} underline fontSize={'16px'}>
              (877) 633-5338
            </StyledLink>{' '}
            / 1-877-63-FLEET
          </StyledText>
        )}
        {platform === PlatformName.NGAM && (
          <StyledText>
            If the issue persists contact{' '}
            <StyledLink
              to={'https://www.ford.com/finance/customer-support/contact-us-phone-number'}
              underline
              fontSize={'16px'}
            >
              customer support
            </StyledLink>{' '}
            for further help.
          </StyledText>
        )}
        <Button onClick={handleClick}>
          <Icon icon={'refresh'} />
          Refresh
        </Button>
      </RaisedSurface.Container>
    </StyledRaisedSurface>
  )
}

export default ErrorFallback
